import React from 'react'
import withLayout from "../../../layout/withLayout";
import {lifecycle} from "recompose";
import PartnerForm from '../form/PartnerForm';
import PropTypes from "prop-types";

const EditPartner = (props) => {
    return(
        <PartnerForm {...props}/>
    )
}

EditPartner.propTypes = {
    partnerId: PropTypes.string.isRequired,
    findPartner: PropTypes.func.isRequired,
    clearState: PropTypes.func.isRequired
}

export default lifecycle({
    componentDidMount() {
        this.props.clearState()
        this.props.findPartner(this.props.partnerId)
    }
})(withLayout(EditPartner))



// WEBPACK FOOTER //
// ./src/modules/partner/component/edit/EditPartner.js